<template>
    <DxScrollView class="opportunity-details-container">
        <div v-if="partener">
            <div class="back-button-section">
                <DxButton icon="arrowleft" text="Înapoi la listă" styling-mode="text" @click="$emit('back')"
                    class="back-btn" />
            </div>

            <div class="opportunity-header">
                <div class="header-top">
                    <div class="header-left">
                        <div class="opportunity-icon">
                            <i class="dx-icon-box"></i>
                        </div>
                        <div class="header-info">
                            <h1 class="opportunity-title">{{ partener.Nume || ' fără nume' }} </h1>
                            <div class="opportunity-meta">
                                <span class="meta-item meta-item--cui" title="CUI" v-if="partener.CUI">
                                    <i class="dx-icon-card"></i>
                                    {{ partener.CUI }}
                                </span>

                                <span class="meta-item meta-item--caen" title="CAEN" v-if="partener.Caen">
                                    <i class="dx-icon-accountbox"></i>
                                    {{ partener.Caen }}
                                </span>

                                <span class="meta-item meta-item--address" title="Adresă" v-if="partener.Strada">
                                    <i class="dx-icon-map"></i>
                                    {{ partener.Strada }}
                                </span>

                                <span class="meta-item meta-item--owner" title="Responsabil (Owner)">
                                    <i class="dx-icon-user"></i>
                                    {{ partener.Owner || 'Fără agent' }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                    </div>
                </div>
            </div>

            <div class="two-column-layout">
                <div class="left-column">
                    <div class="details-card">
                        <div class="card-header">
                            <div class="card-header-icon">
                                <i class="dx-icon-doc"></i>
                            </div>
                            <h3 class="card-header-title">Detalii Partener</h3>
                        </div>
                        <div class="card-body">
                            <partenerForm :partener-data="partener" :is-editing="false" />
                        </div>
                    </div>
                </div>

                <div class="right-column">
                    <div class="section-card">
                        <div class="card-header">
                            <div class="card-header-icon"
                                style="background: linear-gradient(135deg, #10b981 0%, #34d399 100%);">
                                <i class="dx-icon-event"></i>
                            </div>
                            <h3 class="card-header-title">Contacte</h3>
                        </div>
                        <div class="card-body">
                            <CardContacts :partener-id="partener?.ID" :contacts-data="partener"
                                :contact="listaContacte" />
                        </div>
                    </div>

                    <div class="section-card">
                        <div class="card-header">
                            <div class="card-header-icon"
                                style="background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);">
                                <i class="dx-icon-money"></i>
                            </div>
                            <h3 class="card-header-title">Oportunități</h3>
                        </div>
                        <div class="card-body">
                            <CardOpportunities :account-id="partener?.ID" />
                        </div>
                    </div>

                    <div class="section-card">
                        <div class="card-header">
                            <div class="card-header-icon"
                                style="background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);">
                                <i class="dx-icon-task"></i>
                            </div>
                            <h3 class="card-header-title">Activități</h3>
                        </div>
                        <div class="card-body">
                            <CardActivity :account-id="partener?.ID" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="no-opportunity">
            <div class="no-opportunity-icon">
                <i class="dx-icon-box"></i>
            </div>
            <p class="no-opportunity-text">Niciun partener selectat</p>
            <p class="no-opportunity-subtext">Selectează un partener din listă pentru a vedea detaliile</p>
        </div>
    </DxScrollView>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxButton } from 'devextreme-vue/button';
import OpportunityForm from '@/components/library/opportunity-form.vue';
import CardActivity from '@/components/library/card-activity.vue';
import CardProducts from '@/components/library/card-products.vue';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '../../../settings/appSettings'
import contactForm from '../../../components/library/contact-form.vue';
import CardOpportunities from '@/components/library/card-opportunities.vue';
import partenerForm from '../../../components/library/partener-form.vue';
import CardContacts from '@/components/library/card-contacts.vue';

export default defineComponent({
    components: {
        DxScrollView,
        DxButton,
        OpportunityForm,
        CardActivity,
        CardProducts,
        contactForm,
        CardOpportunities,
        partenerForm,
        CardContacts
    },
    props: {
        partener: Object,
    },
    data() {
        return {
            listaContacte: [],
            listaParteneri: [],
            listaIndustrii: [],
            listaCampanii: [],
            listaValute: [],
            listaSurse: [],
            listaTari: [],
            statusSteps: [
                'Nou',
                'Identificat',
                'Calificare',
                'Alte analize',
                'Demo',
                'Ofertare',
                'Negociere',
                'Câștigat'
            ]
        }
    },
    computed: {
        currentStatusIndex(): number {
            if (!this.partener || !this.partener.Status) return -1;
            // Handle "Închis" as a special case or map it to the end if appropriate
            if (this.partener.Status === 'Închis') return this.statusSteps.length;
            return this.statusSteps.indexOf(this.partener.Status);
        },
        isCurrentStatusComplete(): boolean {
            return this.partener?.Status === 'Câștigat' || this.partener?.Status === 'Închis';
        }
    },
    methods: {

        handleStepClick(step: string) {
            // Here you could implement logic to change status on click
            // For now, we just log it or maybe emit an event
            console.log('Clicked step:', step);
        },
        formatCurrency(value: number): string {
            if (!value && value !== 0) return '-';
            return new Intl.NumberFormat('ro-RO', {
                style: 'currency',
                currency: 'RON',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        formatDate(dateString: string): string {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('ro-RO', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).format(date);
        },
        getProbabilityColor(probability: number): string {
            if (probability >= 75) return '#10b981';
            if (probability >= 50) return '#3b82f6';
            if (probability >= 25) return '#f59e0b';
            return '#ef4444';
        }
    },
    mounted() {
        const contacte = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        contacte.load().then(data => {
            this.listaContacte = data;
        });

        const parteneri = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        parteneri.load().then(data => {
            this.listaParteneri = data;
        });

        const industrii = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'CRM_Industrii',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        industrii.load().then(data => {
            this.listaIndustrii = data;
        });

        const campanii = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        campanii.load().then(data => {
            this.listaCampanii = data;
        });

        const valute = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        valute.load().then(data => {
            this.listaValute = data;
        });

        const surse = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        surse.load().then(data => {
            this.listaSurse = data;
        });

        const tari = new ODataStore({
            url: AppSetting.API_Url_ComercialOdata + 'CRM_Tari',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        tari.load().then(data => {
            this.listaTari = data;
        });
    }
});
</script>

<style scoped lang="scss">
.opportunity-details-container {
    background: #f8f9fa;
    min-height: 100vh;
}

/* Back Button */
.back-button-section {
    padding: 1rem 1.5rem 0.5rem;

    .back-btn {
        color: #6b7280;
        font-weight: 500;

        &:hover {
            color: #ff2c21;
        }
    }
}

/* Header Section */
.opportunity-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e5e7eb;
    padding: 1.5rem 1.5rem 1rem;
    /* Reduced bottom padding */
    margin-bottom: 1.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.5rem;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
}

.header-left {
    display: flex;
    gap: 1rem;
    flex: 1;
    min-width: 300px;
}

.opportunity-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #ff2c21 0%, #ff5447 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(255, 44, 33, 0.2);

    i {
        font-size: 28px;
        color: white;
    }
}

.header-info {
    flex: 1;
}

.opportunity-title {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 0.5rem 0;
    line-height: 1.3;
}

.opportunity-meta {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    color: #6b7280;
    font-size: 14px;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 4px 12px;
    border-radius: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    font-weight: 500;
    transition: all 0.2s ease;

    i {
        font-size: 14px;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    &--cui {
        background: #eff6ff;
        color: #1d4ed8;
        border-color: #dbeafe;

        i {
            color: #3b82f6;
        }
    }

    &--caen {
        background: #fefce8;
        color: #a16207;
        border-color: #fef9c3;

        i {
            color: #eab308;
        }
    }

    &--address {
        background: #f0fdf4;
        color: #15803d;
        border-color: #dcfce7;

        i {
            color: #22c55e;
        }
    }

    &--owner {
        background: #faf5ff;
        color: #7e22ce;
        border-color: #f3e8ff;

        i {
            color: #a855f7;
        }
    }
}

.meta-separator {
    display: none;
}

/* Status Path Styling */
.status-path-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
}

.status-path {
    display: flex;
    flex: 1;
    background: #e5e7eb;
    border-radius: 20px;
    /* Rounded pill shape for the whole bar */
    overflow: hidden;
    height: 36px;
}

.status-step {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1.5rem 0 2rem;
    background: #f3f4f6;
    color: #4b5563;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:first-child {
        padding-left: 1.5rem;
    }

    /* Chevron Arrow Effect */
    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: -12px;
        /* Adjust based on angle */
        width: 0;
        height: 0;
        border-top: 18px solid transparent;
        border-bottom: 18px solid transparent;
        border-left: 12px solid #f3f4f6;
        /* Match background */
        z-index: 2;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: -13px;
        /* Border width offset */
        width: 0;
        height: 0;
        border-top: 18px solid transparent;
        border-bottom: 18px solid transparent;
        border-left: 12px solid white;
        /* Separator color */
        z-index: 1;
    }

    /* Completed State */
    &.completed {
        background: #10b981;
        /* Green */
        color: white;

        &::after {
            border-left-color: #10b981;
        }

        &:hover {
            background: #059669;

            &::after {
                border-left-color: #059669;
            }
        }
    }

    /* Current State */
    &.current {
        background: #3b82f6;
        /* Blue */
        color: white;

        &::after {
            border-left-color: #3b82f6;
        }
    }

    /* Future State */
    &.future {
        background: #f3f4f6;
        color: #6b7280;

        &:hover {
            background: #e5e7eb;

            &::after {
                border-left-color: #e5e7eb;
            }
        }
    }

    /* Last child adjustments */
    &:last-child {
        padding-right: 1.5rem;

        &::after,
        &::before {
            display: none;
        }
    }
}

.current-status-action {
    flex-shrink: 0;
}

/* Metrics Section */
.metrics-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    padding: 0 1.5rem 1.5rem;
}

.metric-card {
    background: white;
    border-radius: 12px;
    padding: 1.25rem;
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    transition: all 0.2s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }
}

.metric-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
        font-size: 24px;
    }
}

.metric-content {
    flex: 1;
    min-width: 0;
}

.metric-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 0.375rem;
    text-transform: uppercase;
    letter-spacing: 0.025em;
}

.metric-value {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
}

.metric-value-with-bar {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.probability-bar-small {
    width: 100%;
    height: 6px;
    background: #e5e7eb;
    border-radius: 3px;
    overflow: hidden;
}

.probability-fill-small {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
}

/* Two Column Layout */
.two-column-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    padding: 0 1.5rem 1.5rem;
    align-items: start;
}

.left-column {
    display: flex;
    flex-direction: column;
}

.right-column {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.details-card,
.section-card {
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.card-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #f3f4f6;
    background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
}

.card-header-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
        font-size: 18px;
        color: white;
    }
}

.card-header-title {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.3;
}

.card-body {
    padding: 1.5rem;
}

/* No Opportunity State */
.no-opportunity {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    text-align: center;
}

.no-opportunity-icon {
    width: 80px;
    height: 80px;
    background: #f3f4f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;

    i {
        font-size: 40px;
        color: #9ca3af;
    }
}

.no-opportunity-text {
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 0.5rem 0;
}

.no-opportunity-subtext {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .opportunity-header {
        padding: 1rem;
    }

    .header-content {
        flex-direction: column;
    }

    .header-left {
        width: 100%;
    }

    .status-path-container {
        flex-direction: column;
        align-items: stretch;
    }

    .status-path {
        overflow-x: auto;
        padding-bottom: 5px;
        /* Scrollbar space */
    }

    .metrics-section {
        grid-template-columns: 1fr;
        padding: 0 1rem 1rem;
    }

    .two-column-layout {
        grid-template-columns: 1fr;
        padding: 0 1rem 1rem;
    }

    .opportunity-title {
        font-size: 20px;
    }
}
</style>